import type { Zero } from "@rocicorp/zero";
import { queries } from "../../../shared/queries";

export function preloadPersonalChats(z: Pick<Zero, "preload" | "userID">) {
  const url = new URL(window.location.href);
  if (url.pathname !== "/chats" || url.searchParams.has("userId")) return;

  const preloads = [
    z.preload(queries.personalChatSummaries(undefined)),
    z.preload(queries.connectorsIndex()),
  ];
  const personalChatId = url.searchParams.get("tab");
  if (personalChatId) {
    preloads.push(
      z.preload(queries.loadPersonalChat({ personalChatId, userId: z.userID! }))
    );
  }
  for (const { complete, cleanup } of preloads) {
    void complete.then(cleanup, cleanup);
  }
}
